/* eslint-disable prefer-template */
import React, { useState, useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet-async';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// @mui
import {
    Card,
    Stack,
    Paper,
    Avatar,
    Button,
    Container,
    Typography,
    IconButton,
    TablePagination,
    ListItemIcon,
    Box,
    TextField,
    Tooltip,
    InputAdornment

} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { OrdersStatus, NumberFormatter } from '../utils/helper';

import Grid from '@mui/material/Grid';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';


// table
// eslint-disable-next-line import/order
import { apiUrl } from '../utils/api';
import MUIDataTable from 'mui-datatables';
import { Navigate, useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { AlertDialog } from '../utils/dealog/diloag';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import moment from 'moment';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import CircularProgress from '@mui/material/CircularProgress';

// user Api
import { useGetOrderListApiMutation } from '../redux/services/orders/Orders';
// ----------------------------------------------------------------------
const columns = [
    {
        name: 'name',
        label: 'Name',
        options: {
            filter: true,
            sort: true,
        },

    }, {
        name: 'address',
        label: 'Address',

    },
    {
        name: 'landmark',
        label: 'Landmark',

    },
    {
        name: 'orderNo',
        label: 'OrderNo',

    },
    {
        name: 'finalAmount',
        label: 'FinalaMount',

    },
    {
        name: 'status',
        label: 'Status',

    },
];






const DataLogo = ({ name, path }) => {
    const url = `${apiUrl.deliverprofile}${path}`;
    console.log("deliverProfile", url)
    return (
        <Avatar alt={name} src={url} />

    )
}

const Name = ({ name, id }) => {
    return (
        <>
            <Button variant="text" component={RouterLink} to={`/order-info/${id}`}>{name}</Button>
        </>
    )
}



const Address = ({ address }) => {
    return (
        <>
            <Typography variant="body1">{address}</Typography>
        </>
    )
}
const Landmark = ({ landmark }) => {
    return (
        <>
            <Typography variant="body1">{landmark}</Typography>
        </>
    )
}

const OrderNo = ({ order_no }) => {
    return (
        <>
            <Typography variant="body1">{order_no}</Typography>
        </>
    )
}

const FinalAmount = ({ finalamount }) => {
    return (
        <>
            <Typography variant="body1"><NumberFormatter number={finalamount} /></Typography>
        </>
    )
}

const Created = ({ created }) => {
    return (
        <>
            <Typography variant="body1">{created}</Typography>
        </>
    )
}
const Updated = ({ updated }) => {
    return (
        <>
            <Typography variant="body1">{updated}</Typography>
        </>
    )
}

const Status = ({ status, OrderStatus }) => {
    return (
        <Box>
            <ListItemIcon style={{ justifyContent: "center" }}>
                {OrderStatus(status)}
            </ListItemIcon>
        </Box>
    );
};






export default function OrdarsPage() {
    // user ApiRedux
    const [orderListData, orderload] = useGetOrderListApiMutation()

    const [loadData, setLoadData] = useState(false)
    const [ordersListRow, setOrdersListRow] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleDateChange = (newDates) => {
        setStartDate(newDates[0]);
        setEndDate(newDates[1]);
    };

    const OrdersList = async (from, to) => {

        const body = {
            date_from: from,
            date_to: to
        }
        try {

            const result = await orderListData(body)
            if (result && result.data && result.data.list) {
                const data = result.data.list.map((item) => ({
                    name: <Name name={item.seller.business_name} id={item.id} />,
                    address: <Address address={item.address} />,
                    landmark: <Landmark landmark={item.landmark} />,
                    orderNo: <OrderNo order_no={item.order_no} />,
                    finalAmount: <FinalAmount finalamount={item.final_amount} />,
                    status: <Status status={item.status} OrderStatus={OrdersStatus} />,

                }));
                setOrdersListRow(data);
            } else {
                console.error("Invalid API response:", result);
            }
            console.log("deliveryList", result.data.list)
            setTotalPage(result?.data?.total);
            setCurrentPage(result?.data?.current);



        } catch (error) {
            console.error("Error fetching data:", error);

        }
    }

    const options = {
        filterType: 'dropdown',
        selectableRows: "multiple",
        responsive: "vertical",
        serverSide: true,
        count: totalPage,
        page: currentPage,
        onTableChange: (action, tableState) => {
            if (action === 'changePage') {

                setCurrentPage(tableState.page + currentPage);
            }
        },
    };


    // const OrdersStatus = (status) => {

    //     switch (status) {
    //         case "WAT":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'warning'}>WATING</Label>
    //             );
    //         case "COF":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'info'}>CONFORM</Label>
    //             );
    //         case "PRE":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'info'}>PREPARING</Label>
    //             );
    //         case "RDY":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'primary'}>READY</Label>
    //             );
    //         case "OUT":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'default'}>OUT FOR DELIVERY</Label>
    //             );
    //         case "DEL":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'success'}>DELIVERED</Label>
    //             );
    //         case "CAN":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'error'}>CANCELED</Label>
    //             );
    //         case "SCH":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'secondary'}>SCHEDULED</Label>
    //             );
    //         default:
    //             return status;
    //     }
    // }



    useEffect(() => {

        OrdersList(startDate, endDate);
    }, [startDate, endDate]);



    return (
        <>
            <Helmet>
                <title> Delivery | Minimal UI </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Order
                    </Typography>
                    <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
                        New Order
                    </Button>
                </Stack>
                <Card>
                    <Box sx={{ flexGrow: 1, margin: "30px", }} >

                        <Box sx={{ display: 'flex', justifyContent: "end" }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div>
                                    <DateRangePicker
                                        format="MM/DD/YYYY"
                                        value={[startDate, endDate]}
                                        onChange={(dates) => {
                                            if (dates && dates.length === 2) {
                                                handleDateChange(dates);
                                            } else {
                                                handleDateChange([null, null]);
                                            }
                                        }}
                                    />
                                </div>
                            </LocalizationProvider>

                        </Box>


                    </Box>
                </Card>
                <br />
                <br />
                {orderload.isLoading ? <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : (

                    <Card>
                        <MUIDataTable title={'Order'} data={ordersListRow} columns={columns} options={options} />
                    </Card>
                )}
            </Container>



        </>
    );
}
